import { render, staticRenderFns } from "./rekeningKoran.vue?vue&type=template&id=3a6a6de6&scoped=true&"
import script from "./rekeningKoran.vue?vue&type=script&lang=js&"
export * from "./rekeningKoran.vue?vue&type=script&lang=js&"
import style0 from "./rekeningKoran.vue?vue&type=style&index=0&id=3a6a6de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6a6de6",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QChip,QMenu,QList,QItem,QItemSection,QPagination,QSpace,QDialog,QFile,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QIcon,QChip,QMenu,QList,QItem,QItemSection,QPagination,QSpace,QDialog,QFile,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
